import React from 'react'

function ProductReviews() {
    return (
        <div>Under Development</div>
    )
}

export default ProductReviews